define('components/decorators/filters-finance',[
    'jquery',
    'components/decorator',
    'components/util/financeTreeUtil',
    'components/util/locale'
], function ($, decorator, financeTreeUtil, locale) {

    $.extend(companyInfo.decorators, {
        'finance-template': function () {
            var MAX_INPUTS_COUNT = 3;
            var $component, $formElement, form, translations;
            var dataTemplateHTML;
            var ie9 = $(".ie9"); //for IE9 placeholder problem

            $component = $("[data-financefilter]");
            dataTemplateHTML = $component.find("[data-finance-template]").html();
            $formElement = $component.find("ul").first();
            translations = JSON.parse($component.data("translations"));

            /**
             * initialize the formfields
             */
            var init = function () {
                MAX_INPUTS_COUNT = $component.data("max-count") || MAX_INPUTS_COUNT;
                form = $component.closest('#main-form');
                $component.html("");


                var locationhref = window.location.href.slice(window.location.href.indexOf('?') + 1);
                values = getParams(locationhref);
                companyInfo.finance = disableOptions(companyInfo.finance, values);

                var formTemplate;
                var filterCount = 0;
                for (var key in values) {
                    if (filterCount > MAX_INPUTS_COUNT) {
                        return;
                    }


                    if (Object.keys(values).length > 0) {
                        formTemplate = createForm(dataTemplateHTML, filterCount, values[key], true);
                    } else {
                        formTemplate = createForm(dataTemplateHTML, filterCount, values[key]);
                    }

                    filterCount = filterCount + 1;
                    $component.append(formTemplate);

                }

                //when there are no values, atleast show 1 empty template
                if (filterCount === 0) {
                    formTemplate = createForm(dataTemplateHTML, filterCount);
                    $component.append(formTemplate);
                }
                //add an add button at the bottom of component
                $component.append(addButton(Object.keys(values).length));
            };


            /**
             * create a button that adds an extra set of formfields
             */
            var addButton = function (fieldsCount) {
                if (fieldsCount >= MAX_INPUTS_COUNT) {
                    return;
                }
                var button = $('<a href="javascript:void(null);"><i class="ico ico-plus-circle"></i><span>' + translations["add.extra.filter"] + '</span></a>');
                if (fieldsCount < MAX_INPUTS_COUNT && fieldsCount > 0) {
                    button.on('click', function () {
                        //get the amount of finance filters already there
                        var numb = $("[data-finance-pos]").length;
                        var template = createForm(dataTemplateHTML, numb);

                        $(this).before(template);
                        $(this).addClass("disabled");

                        if (numb+1 >= MAX_INPUTS_COUNT) {
                            $(this).remove();
                        }
                    });
                } else {
                    button = $(button).addClass("disabled");
                }

                return button;
            };

            var removeButton = function (elmNumber) {
                var button = $('<a class="extra-option-remove" href="javascript:void(null);"><i class="ico ico-minus-circle" title="' + translations["clear.extra.filter"] + '"></i></a>');
                button.on('click', function () {
                    //if its the first button, than clear the filters
                    //else remove the filter entirely
                    var parent = $(this).parent();
                    parent = clearValues(parent);
                    if (elmNumber > 0 || Object.keys(values).length > 1) { //Object.keys(values).length
                        parent.remove();
                    }
                    form.trigger("change");

                });
                return button;
            };

            /**
             * clears the values of the formfields in the element
             * @param  {html} elm
             * @return {html}
             */
            var clearValues = function (elm) {
                var inputFields = $(elm).find("input");
                $(elm).find("[name=financeType]").select2("val", "");
                $(inputFields).each(function () {
                    $(this).val("");
                    $(this).attr("placeholder", "");
                });
                return elm;
            };

            /**
             * get the params for financial filters from the url parameters.
             * @return {[type]} [description]
             */
            var getParams = function (locationhref) {
                var vars = {}, hash;
                if (!locationhref) {
                    return {};
                }
                var hashes = locationhref.split('&');
                for (var i = 0; i < hashes.length; i++) {
                    if (!hashes[i]) {
                        continue;
                    }
                    var param = hashes[i];
                    if (param.indexOf('=') < 0) {
                        continue;
                    }
                    hash = param.split('=');
                    var values = hash[1].split('..');
                    if (hash[1].indexOf('..') === -1) {
                        continue;
                    }

                    //check if the paramName (hash[0]) is in the tree
                    if (!financeTreeUtil.inTree(companyInfo.finance, hash[0])) {
                        continue;
                    }

                    var val = {
                        "financeType": hash[0],
                        "financeMin": values[0],
                        "financeMax": values[1]
                    };
                    vars[hash[0]] = val;
                }


                return vars;
            };


            /**
             * create the form per finance type
             * @param  {integer} numb the number of the field
             * @param  {json} values the values of the given finance type
             * @return {htmlobject}
             */
            var createForm = function (templateHTML, numb, values, showRemoveButton) {
                var template = createTemplate(templateHTML, numb, values);
                //if the number of the field is larger than 0 then add a remove button
                if (numb > 0 || showRemoveButton) {
                    template.append(removeButton(numb));
                }
                return template;
            };

            /**
             * create the template and set the right numb for the financetype ('finance-1')
             * @param  {string} html the standard html template
             * @param  {integer} numb the number of the field
             * @param {json} values   values that should be given to the template
             * @return {object}      the html object
             */
            var createTemplate = function (html, numb, val) {
                if (!val) {
                    val = {};
                }


                var str = '<div class="extra-option" data-finance-pos="' + numb + '">';
                if (numb > 0) {
                    str += '<h5>' + translations["filter.title"] + ' (' + (numb + 1) + ')</h5>';
                }
                str += html;
                str += '</div>';
                var template = $(str);


                //loop through all the subfields and set values
                var inputFields = $(template).find("input");
                $(inputFields).each(function () {
                    var $field = $(this);
                    $field.removeAttr("disabled");
                    var newFamilyName = "finance" + numb;
                    $field.attr("data-filter-family", newFamilyName);

                    var parentTree = getParentTree(companyInfo.finance, val.financeType);

                    setFieldValue($field, val, parentTree);
                    setFieldPlaceHolder($field, parentTree);

                    if ($field.data("finance-field") === "type") {
                        $field.on('change', function () {

                            var newParentTree = getParentTree(companyInfo.finance, $(this).val());
                            setFieldPlaceHolder($("[data-filter-family=" + newFamilyName + "][data-finance-field=min]"), newParentTree);
                            setFieldPlaceHolder($("[data-filter-family=" + newFamilyName + "][data-finance-field=max]"), newParentTree);
                        });
                    }

                });


                //create a select2
                var select = $(template).find("[name=financeType]");
                initSelect($(select));
                return template;
            };

            var getParentTree = function (financeTree, name){
                // Overwriting getParentTree to fetch only one level deep and take unit property
                if(!name){return;}
                var treeParent;
                function find(arr, n){
                    if(treeParent){return treeParent;}
                    for(var i=0; i<arr.length; i++){
                        if(arr[i].id === n){
                            treeParent = arr[i].unit;
                        }
                    }
                }

                find(financeTree, name);
                return treeParent;
            };

            var setFieldPlaceHolder = function (elm, financeSelection) {
              //ie9fix, remove placeholders
              if(ie9.length > 0){
                elm.attr('placeholder', '');
                return;
              }

                var name = elm.attr("name");
                if (financeSelection !== "percent") {
                    switch (name) {
                        case "financeMin":
                            elm.attr("placeholder", translations["filter.placeholder.min"]);
                            break;
                        case "financeMax":
                            elm.attr("placeholder", translations["filter.placeholder.max"]);
                            break;
                    }
                } else {
                    switch (name) {
                        case "financeMin":
                            elm.attr("placeholder", translations["filter.placeholder.min.ratio"]);
                            break;
                        case "financeMax":
                            elm.attr("placeholder", translations["filter.placeholder.max.ratio"]);
                            break;
                    }
                }

            };

            var setFieldValue = function (elm, values, selectedFinance) {
                //set the value of the field
                if (values) {
                    var name = elm.attr("name");
                    var v = values[name];

                    if (name !== "financeType") {
                        if (selectedFinance !== "percent") {
                            v = financeTreeUtil.DivideValue(v, 1000);
                        } else {
                            v = locale.getNumeric(v);
                        }
                    }
                    elm.val(v);
                }
            };
            
            /**
             * disable the options that are already used
             */
            var disableOptions = function (array, params) {

                //recursive loop through whole tree.
                //extra...give all the values in the ratios tree a tick
                function loop(arr, parent, rootBranch) {

                    for (var i = 0; i < arr.length; i++) {
                        if (params[arr[i].id] && arr[i].id !== null) {
                            arr[i].disabled = true;
                        } else {
                            arr[i].disabled = false;
                        }

                        if (rootBranch) {
                            switch (i) {
                                case 0:
                                    parent = "balance";
                                    break;
                                case 1:
                                    parent = "profitLoss";
                                    break;
                                case 2:
                                    parent = "ratio";
                                    break;
                            }
                        }
                        arr[i].parent = parent;

                        if (arr[i].children) {
                            arr[i].children = loop(arr[i].children, parent);
                        }
                    }
                    return arr;
                }

                array = loop(array, null, true);
                return array;
            };

            var initSelect = function (elm) {
                //overwrite the select2 clearSearch in prototype, to make sure
                //that the searchterm will stay when you remove focus from the box
                window.Select2.class.multi.prototype.clearSearch = function () {
                    var placeholder = this.getPlaceholder(),
                        maxWidth = this.getMaxSearchWidth();
                    // CurrentThisInput=(this.search); i used this to get the current select2 element and make further action if required.
                    if (this.search.val() !== "") {
                    } else if (placeholder !== undefined && this.getVal().length === 0 && this.search.val() === "") {
                        this.search.val(placeholder).addClass("select2-default");
                        this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
                    }
                };

                if (!companyInfo.finance || !companyInfo.finance.length) {
                    return;
                }

                companyInfo.emptySearch = true;
                $(elm).select2({
                    placeholder: '',
                    minimumResultsForSearch: 1,
                    openOnEnter: false,
                    multiple: false,
                    data: companyInfo.finance,
                    adaptContainerCssClass: function (str) {
                        return str.replace('input', '');
                    },
                    sortResults: function (results, container, query) {
                        companyInfo.emptySearch = (query.term === '');
                        return results;
                    },
                    clearSearch: function () {

                    },
                    transformVal: function(val) {
                      return val;
                    },

                    formatResult: function (result) {
                        return result.text;
                    },
                    escapeMarkup: function (m) {
                        return m;
                    }
                });
            };


            init();
        },
    });


});

